interface CacheEntry {
  data: unknown
  timestamp: number
  ttl: number
}

const cache = new Map<string, CacheEntry>()
export const CACHE_TTL = 5 * 60 * 1000

export function getCachedData(key: string): unknown | null {
  const entry = cache.get(key)
  if (entry && Date.now() - entry.timestamp < entry.ttl) {
    return entry.data
  }
  cache.delete(key)
  return null
}

export function setCacheData(key: string, data: unknown): void {
  cache.set(key, { data, timestamp: Date.now(), ttl: CACHE_TTL })
}
